export default {
    routerList: [
        //========财务管理========
        {
          path: "/WarehouseManagement/storage/list",
          name: "CargoArea",
          component: (resolve) =>
            require([
              "@/pages/WarehouseManagement/storage/list",
            ], (comp) => resolve({ ...comp.default, name: "CargoArea" })),
          meta: {
            title: "堆放货区管理",
            keepAlive: true,
          },
        },

        {
          path: "/WarehouseManagement/stock/list",
          name: "stockList",
          component: (resolve) =>
            require([
              "@/pages/WarehouseManagement/stock/list",
            ], (comp) => resolve({ ...comp.default, name: "stockList" })),
          meta: {
            title: "库存管理",
            keepAlive: true,
          },
        },
        {
          path: "/WarehouseManagement/stock/history",
          name: "stockHistory",
          component: (resolve) =>
            require([
              "@/pages/WarehouseManagement/stock/history",
            ], (comp) => resolve({ ...comp.default, name: "stockHistory" })),
          meta: {
            title: "出入库记录",
            keepAlive: true,
          },
        },
    ]
}